export default __webpack_public_path__ + "static/media/group-annotation.b336169b.png";